import { BaseBlock } from "./BaseBlock";

import type { AccountActions } from "../screens/components/AccountActions";

import type {
    AppState
} from "../app/state/AppState";

type SelectedSubscription =
    NonNullable<
        AppState["selectedSubscription"]
    >;

export class ConfirmCancelSubscriptionBlock
    extends BaseBlock {

    private readonly selected: SelectedSubscription;

    private readonly actions: AccountActions;

    private root!: HTMLElement;

    constructor(
        selected: SelectedSubscription,
        actions: AccountActions
    ) {

        super();

        this.selected = selected;
        this.actions = actions;

    }

    public override mount(): void {

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =====================================================

    private buildRoot(): HTMLElement {

        const card =
            document.createElement("div");

        card.className =
            "sticker-card account-card";

        const title =
            document.createElement("h3");

        title.textContent =
            "Підтвердження відміни автоматичного продовження підписки";

        card.appendChild(
            title
        );

        // =====================================
        // PRODUCT
        // =====================================

        const product =
            document.createElement("p");

        product.innerHTML =
            `<b>${this.selected.product.title}</b>`;

        card.appendChild(
            product
        );

        // =====================================
        // sticker_title
        // =====================================

        const sticker =
            document.createElement("p");

        sticker.innerHTML =
            `<b>${this.selected.subscription.sticker_title}</b>`;

        card.appendChild(
            sticker
        );

        // =====================================
        // INFO
        // =====================================

        const steps =
            document.createElement("p");

        steps.innerHTML =
            `Кількість кроків: <b>${this.selected.subscription.cycle_krok_limit}</b> на <b>${this.selected.subscription.cycle_days}</b> дн.`;

        card.appendChild(
            steps
        );

        const renewal =
            document.createElement("p");

        renewal.innerHTML =
            `Автоматичне продовження через <b>${this.selected.subscription.remaining_days}</b> днів`;

        card.appendChild(
            renewal
        );

        const payment =
            document.createElement("p");

        payment.innerHTML =
            `Наступна оплата: <b>${this.selected.subscription.next_payment_date}</b>`;

        card.appendChild(
            payment
        );

        const warning =
            document.createElement("p");

        warning.style.marginTop =
            "18px";

        warning.textContent =
            "Ви впевнені, що хочете відмінити автоматичне продовження підписки?";

        card.appendChild(
            warning
        );

        // =====================================
        // ACTIONS
        // =====================================

        const actions =
            document.createElement("div");

        actions.className =
            "account-actions";

        const confirm =
            document.createElement("button");

        confirm.className =
            "primary-wide";

        confirm.textContent =
            "Підтвердити";

        confirm.addEventListener(
            "click",
            () => {

                this.actions.cancelSubscription(
                    this.selected.subscription.subscription_id
                );

            }
        );

        actions.appendChild(
            confirm
        );

        const back =
            document.createElement("button");

        back.className =
            "primary-wide cancel-btn";

        back.textContent =
            "Ні, повернутись до навчання";

        back.addEventListener(
            "click",
            () => {

                this.actions.back();

            }
        );

        actions.appendChild(
            back
        );

        card.appendChild(
            actions
        );

        return card;

    }

}